import { Fancybox } from '@fancyapps/ui';
import { Browser } from 'smg/browser';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as errors from 'smg/errors';
import * as session from 'smg/customer-api/session';
import * as html from 'smg/html';
import Modal from 'smg/modal';

import { SetBootstrapVersion } from 'smg/bootstrap';
import { SetIconLibrary } from 'smg/icons';
import * as carts from './carts';

declare interface myWindow extends Window {
    getPageRequestID: typeof GetPageRequestID;
}
declare const window: myWindow;

window.getPageRequestID = GetPageRequestID;

errors.InitClientSideErrorLogging();

// Without this, ShowError falls back to a native window.alert (ts/errors.ts
// Defaults.showErrorFunc). Render a branded modal instead so errors are
// readable and screenshot-friendly — matches signature/plus/depot.
errors.Defaults.showErrorFunc = msg => new Modal({
    body: html.FromString(`<div>
            <i class="fas fa-exclamation-circle w-100 text-center mb-4 fa-4x text-danger"></i>
            <div class="fs-5 text-center">${html.Escape(msg)}</div>
        </div>`),
    cancelText: 'Close',
});

SetIconLibrary('fontAwesome5');
SetBootstrapVersion(5);

Fancybox.bind('[data-fancybox]');

async function main() {
    await session.ConsumeLoginTokenFromURL();
    // Page tracking starts after the exchange so the page request belongs to the
    // account the link signed in, not whoever was signed in before.
    void GetPageRequestID();

    document.body.classList.add(`browser-${Browser()}`);

    // Seed cart badges from the server on every page load
    void carts.GetCartCount().then(count => {
        if (count) {
            carts.SetCartCount(count);
        }
    });
}

void main();